import React, { useState, useRef, useEffect } from "react";
import "./buyItems.scss";

// 🧩 תוויות ידידותיות לניווט (שומר על סדר קבוע)
const CATEGORY_ORDER = [
  "ancients", // 👈 הקטגוריה החדשה
  "sets",
  "wings",
  "bkWeapons",
  "smWeapons",
  "mgWeapons",
  "dlWeapons",
  "elfWeapons",
  "shields",
  "accessories",
  "fullSetsInfo", // ✅ הקטגוריה החדשה
];

const LABELS = {
  ancients: "Ancient Sets",
  sets: "Sets",
  wings: "Wings",
  bkWeapons: "BK Weapons",
  smWeapons: "DW Weapons",
  mgWeapons: "MG Weapons",
  dlWeapons: "DL Weapons",
  elfWeapons: "Elf Weapons",
  shields: "Shields",
  accessories: "Rings & Pendants",
  fullSetsInfo: "Full Sets Info & Purchase",
};

const shopItems = {
  sets: {
    BK: [
      { name: "Leather Set", price: 4600, command: "/buyleather" },
      { name: "Bronze Set", price: 4750, command: "/buybronze" },
      { name: "Brass Set", price: 6700, command: "/buybrass" },
      { name: "Plate Set", price: 6950, command: "/buyplate" },
      { name: "Scale Set", price: 8850, command: "/buyscale" },
      { name: "Dragon Set", price: 9950, command: "/buydragon" },
      { name: "Black Set", price: 12250, command: "/buyblack" },
      { name: "Phonix Set", price: 14550, command: "/buyphonix" },
      { name: "Great Set", price: 16850, command: "/buygreat" },
      { name: "White Warrior Set", price: 20900, command: "/buywhitewarrior" },
    ],
    LORD: [
      { name: "Light Plate Set", price: 5550, command: "/buylightplate" },
      { name: "Adamatine Set", price: 7850, command: "/buyadama" },
      { name: "Dark Steel Set", price: 9150, command: "/buydarksteel" },
      { name: "Master Set", price: 12250, command: "/buymaster" },
      { name: "Gold Warrior Set", price: 18700, command: "/buygoldwarrior" },
    ],
    SM: [
      { name: "Pad Set", price: 4650, command: "/buypad" },
      { name: "Sphinx Set", price: 5750, command: "/buysphinx" },
      { name: "Bone Set", price: 6650, command: "/buybone" },
      { name: "Legendary Set", price: 7750, command: "/buylegendary" },
      { name: "Grand Soul Set", price: 11350, command: "/buygrandsoul" },
      { name: "Dark Soul Set", price: 14350, command: "/buydarksoul" },
    ],
    ELF: [
      { name: "Vine Set", price: 3450, command: "/buyvine" },
      { name: "Silk Set", price: 3650, command: "/buysilk" },
      { name: "Spirit Set", price: 4750, command: "/buyspirit" },
      { name: "Wind Set", price: 6650, command: "/buywind" },
      { name: "Guardian Set", price: 6950, command: "/buyguardian" },
      { name: "Divine Set", price: 10300, command: "/buydivine" },
      { name: "Red Set", price: 12450, command: "/buyred" },
    ],
    MG: [
      { name: "Storm Set", price: 4750, command: "/buystorm" },
      { name: "Thunder Set", price: 9200, command: "/buythunder" },
      { name: "Hurricane Set", price: 11400, command: "/buyhurricane" },
    ],
  },

  // 🆕 סטים עתיקים – מחולק לפי דמות, כל פריט תומך בשתי תמונות
  // תמלא כאן לפי הקבצים ששלחת (דוגמה למבנה):
  ancients: {
    BK: [
      {
        name: "Kantata Set",
        images: [
          {
            src: "/images/ancients/bk/Plate/Plate_complements.jpg",
            alt: "Ancient Kantata Set - Front",
          },
          {
            src: "/images/ancients/bk/Plate/Plate.jpg",
            alt: "Ancient Kantata Set - Back",
          },
        ],
      },

      {
        name: "Eplete Set",
        images: [
          {
            src: "/images/ancients/bk/scale/scale_complements.jpg",
            alt: "Ancient Eplete Set - Front",
          },
          {
            src: "/images/ancients/bk/scale/scale.jpg",
            alt: "Ancient Eplete Set - Back",
          },
        ],
      },

      {
        name: "Hyperion Set",
        images: [
          {
            src: "/images/ancients/bk/bronze/bronze_complements.jpg",
            alt: "Ancient Hyperion Set - Front",
          },
          {
            src: "/images/ancients/bk/bronze/bronze.jpg",
            alt: "Ancient Hyperion Set - Back",
          },
        ],
      },

      {
        name: "Garuda Set",
        images: [
          {
            src: "/images/ancients/bk/garuda/garuda_complements.jpg",
            alt: "Ancient Garuda Set - Front",
          },
          {
            src: "/images/ancients/bk/garuda/garuda.jpg",
            alt: "Ancient Garuda Set - Back",
          },
        ],
      },

      {
        name: "Warrior Set",
        images: [
          {
            src: "/images/ancients/bk/leather/leather_complements.jpg",
            alt: "Ancient Warrior Set - Front",
          },
          {
            src: "/images/ancients/bk/leather/leather.jpg",
            alt: "Ancient Warrior Set - Back",
          },
        ],
      },

      {
        name: "Hyon Set",
        images: [
          {
            src: "/images/ancients/bk/hyon/hyon_complements.jpg",
            alt: "Ancient Hyon Set - Front",
          },
          {
            src: "/images/ancients/bk/hyon/hyon.jpg",
            alt: "Ancient Hyon Set - Back",
          },
        ],
      },

      {
        name: "Hyon Garuda",
        images: [
          {
            src: "/images/ancients/bk/hayongaruda/hayongaruda_complements.jpg",
            alt: "Ancient Hyon Garuda Set - Front",
          },
          {
            src: "/images/ancients/bk/hayongaruda/hayongaruda.jpg",
            alt: "Ancient Hyon Garuda Set - Back",
          },
        ],
      },
      // ...עוד סטים עתיקים ל-BK
    ],
    SM: [
      {
        name: "Apollo",
        images: [
          {
            src: "/images/ancients/sm/Pad/Pad_complements.jpg",
            alt: "Ancient Apollo Set - Front",
          },
          {
            src: "/images/ancients/sm/Pad/Pad.jpg",
            alt: "Ancient Apollo Set - Back",
          },
        ],
      },

      {
        name: "Heras",
        images: [
          {
            src: "/images/ancients/sm/sphinx/sphinx_complements.jpg",
            alt: "Ancient Hera Set - Front",
          },
          {
            src: "/images/ancients/sm/sphinx/sphinx.jpg",
            alt: "Ancient Hera Set - Back",
          },
        ],
      },

      {
        name: "Evis",
        images: [
          {
            src: "/images/ancients/sm/Bone/Bone_complements.jpg",
            alt: "Ancient Evis Set - Front",
          },
          {
            src: "/images/ancients/sm/Bone/Bone.jpg",
            alt: "Ancient Evis Set - Back",
          },
        ],
      },

      {
        name: "Anubis",
        images: [
          {
            src: "/images/ancients/sm/legendary/legendary_complements.jpg",
            alt: "Ancient Anubis Set - Front",
          },
          {
            src: "/images/ancients/sm/legendary/legendary.jpg",
            alt: "Ancient Anubis Set - Back",
          },
        ],
      },

      {
        name: "Anubis Haras",
        images: [
          {
            src: "/images/ancients/sm/anubishars/anubishars_complements.jpg",
            alt: "Ancient Anubis Haras Set - Front",
          },
          {
            src: "/images/ancients/sm/anubishars/anubishars.jpg",
            alt: "Ancient Anubis Haras Set - Back",
          },
        ],
      },
    ],
    ELF: [
      {
        name: "Argo",
        images: [
          {
            src: "/images/ancients/elf/spirit/spirit_complements.jpg",
            alt: "Ancient Argo Set - Front",
          },
          {
            src: "/images/ancients/elf/spirit/spirit.jpg",
            alt: "Ancient Argo Set - Back",
          },
        ],
      },

      {
        name: "Ceto",
        images: [
          {
            src: "/images/ancients/elf/vine/vine_complements.jpg",
            alt: "Ancient Ceto Set - Front",
          },

          {
            src: "/images/ancients/elf/vine/vine.jpg",
            alt: "Ancient Ceto Set - Back",
          },
        ],
      },

      {
        name: "Gaia",
        images: [
          {
            src: "/images/ancients/elf/silk/silk.jpg",
            alt: "Ancient Gaia Set - Back",
          },

          {
            src: "/images/ancients/elf/silk/silk_complements.jpg",
            alt: "Ancient Gaia Set - Front",
          },
        ],
      },

      {
        name: "Odin",
        images: [
          {
            src: "/images/ancients/elf/wind/wind.jpg",
            alt: "Ancient Odin Set - Back",
          },

          {
            src: "/images/ancients/elf/wind/wind_complements.jpg",
            alt: "Ancient Odin Set - Front",
          },
        ],
      },

      {
        name: "Gywen",
        images: [
          {
            src: "/images/ancients/elf/guardian/guardian_complements.jpg",
            alt: "Ancient Gywen Set - Front",
          },
          {
            src: "/images/ancients/elf/guardian/guardian.jpg",
            alt: "Ancient Gywen Set - Back",
          },
        ],
      },
    ],
    MG: [
      {
        name: "Gaion",
        images: [
          {
            src: "/images/ancients/mg/Gaion/Gaion_complements.jpg",
            alt: "Ancient Gaion Set - Front",
          },
          {
            src: "/images/ancients/mg/Gaion/Gaion.jpg",
            alt: "Ancient Gaion Set - Back",
          },
        ],
      },
    ],
    // תוסיף כל דמות שיש לך אליה סטים עתיקים
  },

  wings: [
    { name: "Wings of MG", price: 1100, command: "/buywingmg" },
    { name: "Cape of DL", price: 1300, command: "/buycape" },
    { name: "Wings of ELF", price: 1300, command: "/buywingelf" },
    { name: "Wings of SM", price: 2150, command: "/buywingsm" },
    { name: "Wings of BK", price: 2400, command: "/buywingbk" },
  ],
  bkWeapons: [
    { name: "Knight Blade Sword", price: 1100, command: "/buyknight" },
    { name: "Bone Blade Sword", price: 3300, command: "/buyboneblade" },
    { name: "Illusion Sword", price: 3500, command: "/buyillusion" },
    { name: "Poison Sword", price: 3900, command: "/buypoison" },
    { name: "Warlock Sword", price: 4100, command: "/buywarlock" },
    { name: "Ultimate Sword", price: 4600, command: "/buyultimate" },
    { name: "Titan Sword", price: 5600, command: "/buytitan" },
    { name: "White Warrior Sword", price: 7200, command: "/buywhite" },
  ],
  smWeapons: [
    { name: "Kundun Staff", price: 1300, command: "/buykundun" },
    { name: "Legendary Staff", price: 3500, command: "/buylegendarystaff" },
    { name: "Dragon Soul", price: 4800, command: "/buydragonsoul" },
    { name: "Magic Staff", price: 11400, command: "/buymagic" },
  ],
  mgWeapons: [
    { name: "Daybreak Sword", price: 5800, command: "/buydaybreak" },
    { name: "Dancer Sword", price: 9000, command: "/buydancer" },
  ],
  dlWeapons: [
    { name: "Great Lord Weapon", price: 1100, command: "/buygreatlord" },
    { name: "Gold Warrior Weapon", price: 11000, command: "/buyscgoldwarrior" },
  ],
  elfWeapons: [
    { name: "Arrow Viper Bow", price: 1300, command: "/buyarrowviper" },
    { name: "Element Mace", price: 1300, command: "/buyelementmace" },
    { name: "Grear Region Bow", price: 7700, command: "/buyregion" },
  ],
  shields: [
    { name: "Element Shield", price: 1300, command: "/buyelementshield" },
    { name: "Grand Soul Shield", price: 1300, command: "/buygrandshield" },
    { name: "Dragon Shield", price: 2200, command: "/buydragonshield" },
    { name: "Legendary Shield", price: 3300, command: "/buylegendaryshield" },
    { name: "Bronze Shield", price: 5700, command: "/buybronzeshield" },
    { name: "Magic Shield", price: 11000, command: "/buymagicshield" },
    { name: "Gold Warrior Shield", price: 12500, command: "/buygoldshield" },
    { name: "White Warrior Shield", price: 14400, command: "/buywhiteshield" },
  ],
  accessories: [
    { name: "Ice Ring", price: 250, command: "/buyicering" },
    { name: "Light Pendant", price: 350, command: "/buylightpendant" },
    { name: "Wind Ring", price: 1750, command: "/buywindring" },
    { name: "Wind Pendant", price: 2000, command: "/buywindpendant" },
  ],

  fullSetsInfo: [
    {
      name: "General set information",
      description: `
BK sets include:
Ice set + Wings + Night pair
(Upgrades and extra items available for an additional fee)

Dark Wizard sets include:
Ice set + Wings + Condor and Grand Shield
(Upgrades and extra items available for an additional fee)

Elf sets include:
Ice set + Wings + Elf bow
(Upgrades and extra items available for an additional fee)

Dark Lord sets include:
Ice set + Cape + Great Lord Scepter + Spikes
(Upgrades and extra items available for an additional fee)

Magic Gladiator sets include:
Ice set + Wings + Reign
(Upgrades and extra items available for an additional fee)

-----------------------

Higher-tier character sets also include a Spirit set.
Sets that receive this bonus:

BK:
Black | Phoenix | Great | White Warrior

Dark Lord:
Dark Master | Gold Warrior

Dark Wizard:
Grand Soul | Dark Soul

Elf:
Divine | Red Spirit

Magic Gladiator:
Hurricane

-----------------------

BK prices:
Leather - 150 ILS
Bronze - 170 ILS
Brass - 200 ILS
Plate - 220 ILS
Dragon - 250 ILS
Scale - 270 ILS
Black - 300 ILS
Phoenix - 350 ILS
Great - 380 ILS
White Warrior - 430 ILS

-----------------------

Dark Lord prices:
Light Plate - 250 ILS
Adamantine - 270 ILS
Dark Steel - 300 ILS
Master - 350 ILS
Gold Warrior - 430 ILS

-----------------------

Dark Wizard prices:
Pad - 150 ILS
Bone - 160 ILS
Legendary - 180 ILS
Sphinx - 200 ILS
Grand Soul - 250 ILS
Dark Soul - 280 ILS

-----------------------

Elf prices:
Vine - 150 ILS
Silk - 160 ILS
Spirit - 180 ILS
Wind - 190 ILS
Guardian - 200 ILS
Divine - 250 ILS
Red - 280 ILS

-----------------------

Magic Gladiator prices:
Storm - 150 ILS
Thunder - 250 ILS
Hurricane - 280 ILS

-----------------------

To purchase sets through server management:
Message 050-4707077
    `,
    },
  ],
};

const isGroupedCategory = (key) =>
  typeof shopItems[key] === "object" && !Array.isArray(shopItems[key]);

const ShopTabs = () => {
  const scrollTargetRef = useRef(null);
  const categories = CATEGORY_ORDER.filter((k) => shopItems[k]);
  const [selectedCategory, setSelectedCategory] = useState(categories[0]);

  const [selectedItem, setSelectedItem] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleRowClick = (item) => {
    setSelectedItem(item);
    setIsModalOpen(true);
  };

  useEffect(() => {
    const yOffset = -80;
    const y =
      scrollTargetRef.current.getBoundingClientRect().top +
      window.pageYOffset +
      yOffset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }, []);

  const isAncients = selectedCategory === "ancients";
  const isfullSets = selectedCategory === "fullSetsInfo";

  return (
    <div
      ref={scrollTargetRef}
      className={`shop-tabs-container ${
        selectedCategory === "ancients" ? "is-ancients" : ""
      }`}
    >
      <h2 className="shop-tabs-title">Shop Categories</h2>

      <div className="shop-tabs">
        {categories.map((cat) => (
          <button
            key={cat}
            className={`shop-tab-button ${
              selectedCategory === cat ? "active" : ""
            }`}
            onClick={() => setSelectedCategory(cat)}
          >
            {LABELS[cat] ||
              cat.replace(/([a-z])([A-Z])/g, "$1 $2").toUpperCase()}
          </button>
        ))}
      </div>

      <div className="shop-table-scroll">
        <table className="shop-table">
          <thead>
            <tr>
              {!isAncients && !isfullSets && <th>#</th>}
              {!isAncients && !isfullSets && <th>Item</th>}
              {!isAncients && !isfullSets && <th>Price (Credits)</th>}
              {!isAncients && !isfullSets && <th>Command</th>}
            </tr>
          </thead>
          {selectedCategory === "fullSetsInfo" && (
            <tr>
              <td
                colSpan="4"
                style={{
                  textAlign: "left",
                  whiteSpace: "pre-wrap",
                  lineHeight: "1.7",
                }}
              >
                {shopItems.fullSetsInfo[0].description}
              </td>
            </tr>
          )}
          <tbody>
            {isGroupedCategory(selectedCategory)
              ? Object.entries(shopItems[selectedCategory]).map(
                  ([character, items]) => (
                    <React.Fragment key={character}>
                      <tr className="category-header-row">
                        <td
                          colSpan={isAncients ? 1 : 4}
                          className="category-header-cell"
                        >
                          {character}
                        </td>
                      </tr>
                      {items.map((item, index) => (
                        <tr
                          key={`${character}-${item.name}`}
                          onClick={() => handleRowClick(item)}
                          style={{ cursor: "pointer" }}
                        >
                          {!isAncients && !isfullSets && <td>{index + 1}</td>}
                          <td>{item.name}</td>
                          {!isAncients && !isfullSets && (
                            <td className="priceItems">{item.price}</td>
                          )}
                          {!isAncients && !isfullSets && (
                            <td className="commandCell">{item.command}</td>
                          )}
                        </tr>
                      ))}
                    </React.Fragment>
                  )
                )
              : shopItems[selectedCategory].map((item, index) => (
                  <tr
                    key={item.name}
                    onClick={() => handleRowClick(item)}
                    style={{ cursor: "pointer" }}
                  >
                    {!isAncients && !isfullSets && <td>{index + 1}</td>}

                    {!isfullSets && <td>{item.name}</td>}

                    {!isAncients && !isfullSets && (
                      <td className="priceItems">{item.price}</td>
                    )}
                    {!isAncients && !isfullSets && (
                      <td className="commandCell">{item.command}</td>
                    )}
                  </tr>
                ))}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      {isModalOpen && selectedItem && (
        <div className="modal-overlay" onClick={() => setIsModalOpen(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>{selectedItem.name}</h3>

            {/* ancients: מציג רק תמונות; אחרת תמונה אחת + פרטים */}
            {Array.isArray(selectedItem.images) &&
            selectedItem.images.length > 0 ? (
              <div className="modal-images-two">
                {selectedItem.images.slice(0, 2).map((img, i) => (
                  <img
                    key={i}
                    src={img.src}
                    alt={img.alt || selectedItem.name}
                    className="modal-image"
                  />
                ))}
              </div>
            ) : (
              <img
                src={`/images/items/${selectedItem.name
                  .replace(/\s+/g, "_")
                  .toLowerCase()}.jpg`}
                alt={selectedItem.name}
                className="modal-image"
              />
            )}

            {!isAncients && !isfullSets && (
              <>
                <p>
                  Price:{" "}
                  <span className="priceItems">{selectedItem.price}</span>
                </p>
                <p>
                  Command: <code>{selectedItem.command}</code>
                </p>
              </>
            )}

            <button
              onClick={() => setIsModalOpen(false)}
              className="modal-close"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShopTabs;
